import ColorPicker from "../../components/picker/ColorPicker";

export default function ClockCellProperties({ cell, onChange }) {
    const styles = cell.styles_properties || {};

    const updateStyle = (key, value) => {
        onChange(cell.id, {
            styles_properties: { ...styles, [key]: value },
            type: cell.type
        });
    };

    return (
        <div className="property-section">
            <div className="property-section-title">⏰ Horloge</div>

            {/* Mode */}
            <div className="property-row">
                <div className="property-label">Mode</div>
                <select
                    className="property-input property-input-small"
                    value={styles.mode || 'clock'}
                    onChange={(e) => updateStyle('mode', e.target.value)}
                >
                    <option value="clock">🕐 Horloge temps réel</option>
                    <option value="countdown">⏳ Compte à rebours</option>
                    <option value="stopwatch">⏱️ Chronomètre</option>
                </select>
            </div>

            {/* Style */}
            <div className="property-row">
                <div className="property-label">Style d'affichage</div>
                <select
                    className="property-input property-input-small"
                    value={styles.style || 'digital'}
                    onChange={(e) => updateStyle('style', e.target.value)}
                >
                    <option value="digital">📟 Digital</option>
                    <option value="analog">🕰️ Analogique (aiguilles)</option>
                    <option value="flip">🔢 Flip Clock (rétro)</option>
                    <option value="minimal">✨ Minimal</option>
                    <option value="neon">💡 Néon</option>
                    <option value="lcd">🖩 LCD</option>
                </select>
            </div>

            {/* Format heure */}
            <div className="property-section-title" style={{ marginTop: '16px' }}>Format</div>
            
            <div className="property-row">
                <div className="property-label">Format 24h</div>
                <input
                    type="checkbox"
                    checked={styles.use_24h !== false}
                    onChange={(e) => updateStyle('use_24h', e.target.checked)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Afficher les secondes</div>
                <input
                    type="checkbox"
                    checked={styles.show_seconds !== false}
                    onChange={(e) => updateStyle('show_seconds', e.target.checked)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Afficher les millisecondes</div>
                <input
                    type="checkbox"
                    checked={styles.show_milliseconds || false}
                    onChange={(e) => updateStyle('show_milliseconds', e.target.checked)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Afficher la date</div>
                <input
                    type="checkbox"
                    checked={styles.show_date || false}
                    onChange={(e) => updateStyle('show_date', e.target.checked)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Afficher le jour</div>
                <input
                    type="checkbox"
                    checked={styles.show_day || false}
                    onChange={(e) => updateStyle('show_day', e.target.checked)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Animations</div>
                <input
                    type="checkbox"
                    checked={styles.animate !== false}
                    onChange={(e) => updateStyle('animate', e.target.checked)}
                />
            </div>

            {/* Countdown specific */}
            {(styles.mode === 'countdown' || styles.mode === 'stopwatch') && (
                <>
                    <div className="property-section-title" style={{ marginTop: '16px' }}>
                        {styles.mode === 'countdown' ? '⏳ Compte à rebours' : '⏱️ Chronomètre'}
                    </div>

                    <div className="property-row">
                        <div className="property-label">Date cible</div>
                        <input
                            type="datetime-local"
                            className="property-input property-input-small"
                            value={styles.target_date ? new Date(styles.target_date).toISOString().slice(0, 16) : ''}
                            onChange={(e) => updateStyle('target_date', new Date(e.target.value).toISOString())}
                        />
                    </div>

                    <div className="property-row">
                        <div className="property-label">Label</div>
                        <input
                            type="text"
                            className="property-input property-input-small"
                            placeholder="Ouverture dans..."
                            value={styles.countdown_label || ''}
                            onChange={(e) => updateStyle('countdown_label', e.target.value)}
                        />
                    </div>

                    <div className="property-row">
                        <div className="property-label">Afficher les jours</div>
                        <input
                            type="checkbox"
                            checked={styles.show_days !== false}
                            onChange={(e) => updateStyle('show_days', e.target.checked)}
                        />
                    </div>

                    <div className="property-row">
                        <div className="property-label">Afficher les heures</div>
                        <input
                            type="checkbox"
                            checked={styles.show_hours !== false}
                            onChange={(e) => updateStyle('show_hours', e.target.checked)}
                        />
                    </div>

                    <div className="property-row">
                        <div className="property-label">Afficher les minutes</div>
                        <input
                            type="checkbox"
                            checked={styles.show_minutes !== false}
                            onChange={(e) => updateStyle('show_minutes', e.target.checked)}
                        />
                    </div>

                    {styles.mode === 'countdown' && (
                        <>
                            <div className="property-row">
                                <div className="property-label">Masquer quand terminé</div>
                                <input
                                    type="checkbox"
                                    checked={styles.hide_when_complete || false}
                                    onChange={(e) => updateStyle('hide_when_complete', e.target.checked)}
                                />
                            </div>

                            <div className="property-row">
                                <div className="property-label">Message de fin</div>
                                <input
                                    type="text"
                                    className="property-input property-input-small"
                                    placeholder="🎉 C'est maintenant !"
                                    value={styles.complete_message || ''}
                                    onChange={(e) => updateStyle('complete_message', e.target.value)}
                                />
                            </div>
                        </>
                    )}
                </>
            )}

            {/* Timezone */}
            <div className="property-section-title" style={{ marginTop: '16px' }}>Fuseau horaire</div>
            
            <div className="property-row">
                <div className="property-label">Timezone</div>
                <select
                    className="property-input property-input-small"
                    value={styles.timezone || ''}
                    onChange={(e) => updateStyle('timezone', e.target.value || null)}
                >
                    <option value="">🌍 Local (navigateur)</option>
                    <option value="Europe/Paris">🇫🇷 Paris</option>
                    <option value="Europe/London">🇬🇧 Londres</option>
                    <option value="Europe/Brussels">🇧🇪 Bruxelles</option>
                    <option value="America/New_York">🇺🇸 New York</option>
                    <option value="America/Los_Angeles">🇺🇸 Los Angeles</option>
                    <option value="Asia/Tokyo">🇯🇵 Tokyo</option>
                    <option value="Asia/Dubai">🇦🇪 Dubai</option>
                    <option value="Australia/Sydney">🇦🇺 Sydney</option>
                </select>
            </div>

            {/* Couleurs */}
            <div className="property-section-title" style={{ marginTop: '16px' }}>Couleurs</div>

            <div className="property-row">
                <div className="property-label">Couleur principale</div>
                <ColorPicker
                    value={styles.primary_color || '#6366f1'}
                    onChange={(color) => updateStyle('primary_color', color)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Couleur secondaire</div>
                <ColorPicker
                    value={styles.secondary_color || '#8b5cf6'}
                    onChange={(color) => updateStyle('secondary_color', color)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Couleur du texte</div>
                <ColorPicker
                    value={styles.text_color || '#ffffff'}
                    onChange={(color) => updateStyle('text_color', color)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Couleur d'accent</div>
                <ColorPicker
                    value={styles.accent_color || '#22d3ee'}
                    onChange={(color) => updateStyle('accent_color', color)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Couleur de fond</div>
                <ColorPicker
                    value={styles.background_color || 'transparent'}
                    onChange={(color) => updateStyle('background_color', color)}
                />
            </div>

            {/* Apparence */}
            <div className="property-section-title" style={{ marginTop: '16px' }}>Apparence</div>

            <div className="property-row">
                <div className="property-label">Échelle</div>
                <input
                    type="range"
                    min="5"
                    max="200"
                    step="1"
                    value={Math.round((styles.scale || 1) * 100)}
                    onChange={(e) => updateStyle('scale', parseInt(e.target.value, 10) / 100)}
                    style={{ width: '100px' }}
                />
                <span style={{ marginLeft: '8px', fontSize: '12px', color: '#888' }}>
                    {Math.round((styles.scale || 1) * 100)}%
                </span>
            </div>

            <div className="property-row">
                <div className="property-label">Afficher le fond</div>
                <input
                    type="checkbox"
                    checked={styles.show_background !== false}
                    onChange={(e) => updateStyle('show_background', e.target.checked)}
                />
            </div>

            <div className="property-row">
                <div className="property-label">Intensité du glow</div>
                <input
                    type="range"
                    min="0"
                    max="100"
                    value={styles.glow_intensity || 0}
                    onChange={(e) => updateStyle('glow_intensity', parseInt(e.target.value))}
                    style={{ width: '100px' }}
                />
                <span style={{ marginLeft: '8px', fontSize: '12px', color: '#888' }}>
                    {styles.glow_intensity || 0}%
                </span>
            </div>

            <div className="property-row">
                <div className="property-label">Arrondi des bords</div>
                <input
                    type="number"
                    className="property-input property-input-small"
                    min="0"
                    max="50"
                    value={styles.border_radius ?? 16}
                    onChange={(e) => updateStyle('border_radius', parseInt(e.target.value) || 0)}
                    style={{ width: '60px' }}
                />
                <span style={{ marginLeft: '8px', fontSize: '12px', color: '#888' }}>px</span>
            </div>

            <div className="property-row">
                <div className="property-label">Police</div>
                <select
                    className="property-input property-input-small"
                    value={styles.font_family || "'Inter', sans-serif"}
                    onChange={(e) => updateStyle('font_family', e.target.value)}
                >
                    <option value="'Inter', sans-serif">Inter</option>
                    <option value="'SF Pro Display', sans-serif">SF Pro</option>
                    <option value="'Roboto', sans-serif">Roboto</option>
                    <option value="'Orbitron', sans-serif">Orbitron (futuriste)</option>
                    <option value="'Space Mono', monospace">Space Mono</option>
                    <option value="'JetBrains Mono', monospace">JetBrains Mono</option>
                    <option value="'Courier New', monospace">Courier New</option>
                </select>
            </div>
        </div>
    );
}

